import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = function (state, payload) {
  state.rows = payload
}
mutations.COUNTRY_LIST = function (state, payload) {
  state.country_list = payload
}
mutations.PHONE_LIST = function (state, payload) {
  state.phone_list = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  country_list: null,
  phone_list: null
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        getCountryListSelectBox: { api: 'C0001CountryService.getCountryListSelectBox' },
        getPhoneListSelectBox: { api: 'C0001CountryService.getPhoneListSelectBox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('COUNTRY_LIST', data.getCountryListSelectBox.output)
        commit('PHONE_LIST', data.getPhoneListSelectBox.output)
      })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
